<li *ngIf="link.show()" [class.sub-menu]="link.subMenu" [class.current-page]="isCurrentPath">
  <a *ngIf="link.external" [href]="link.to" target="_blank">
    <!-- display external link-->
    <i *ngIf="link.icon" [ngClass]="link.icon"></i>
    <span>{{ link.label }}</span>
  </a>
  <a *ngIf="!link.external" [routerLink]="link.to" routerLinkActive="active-link" (click)="emitClick(link)">
    <!-- display app nav link-->
    <i *ngIf="link.icon" [ngClass]="link.icon"></i>
    <span>{{ link.label }}</span>
  </a>
</li>
